<main class="c-main wow-consulta">
  <div class="container-fluid">
    <div class="row">
      <div class="alert alert-danger" role="alert" *ngFor="let erro of mensagemErros">{{ erro }}</div>
    </div>
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-consulta__header">
          <div class="wow-consulta__header-icon"><mat-icon>color_lens</mat-icon></div>
          <mat-card-title>Produtos</mat-card-title>
        </div>

        <app-wow-consulta-filtros
          [tipoFiltros]="tipoFiltros"
          [(tipoFiltro)]="tipoFiltro"
          [(parametro)]="parametro"
          [parametroMask]="tipoFiltro === 'ID' ? 'separator.0' : ''"
          [showSituacao]="true"
          [(situacao)]="situacao"
          (consultar)="consultar()"
          (novo)="novo()">
        </app-wow-consulta-filtros>

        <div class="wow-consulta__empty" *ngIf="!consultaRealizada">
          Clique em <strong>Consultar</strong> para listar os produtos cadastrados.
        </div>

        <ng-container *ngIf="consultaRealizada">
          <table mat-table [dataSource]="products" class="full-width">
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>ID</th>
              <td mat-cell *matCellDef="let product">{{ product.id }}</td>
            </ng-container>
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Nome</th>
              <td mat-cell *matCellDef="let product">{{ product.name }}</td>
            </ng-container>
            <ng-container matColumnDef="pricePort">
              <th mat-header-cell *matHeaderCellDef>Preço Portaria</th>
              <td mat-cell *matCellDef="let product">{{ product.pricePort | currency:'BRL' }}</td>
            </ng-container>
            <ng-container matColumnDef="price">
              <th mat-header-cell *matHeaderCellDef>Preço Entrega</th>
              <td mat-cell *matCellDef="let product">{{ product.price | currency:'BRL' }}</td>
            </ng-container>
            <ng-container matColumnDef="stockQuantity">
              <th mat-header-cell *matHeaderCellDef>Estoque</th>
              <td mat-cell *matCellDef="let product">{{ product.stockQuantity }}</td>
            </ng-container>
            <ng-container matColumnDef="active">
              <th mat-header-cell *matHeaderCellDef>Status</th>
              <td mat-cell *matCellDef="let product">
                <span [class.text-primary]="product.active" [class.text-danger]="!product.active">
                  {{ product.active ? 'Ativo' : 'Inativo' }}
                </span>
              </td>
            </ng-container>
            <ng-container matColumnDef="excluir">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let product" (click)="$event.stopPropagation()">
                <button (click)="openDialog(product.id)" mat-icon-button color="warn" matTooltip="Excluir">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>
            <ng-container matColumnDef="editar">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let product" (click)="$event.stopPropagation()">
                <button (click)="editar(product.id)" mat-icon-button color="accent" matTooltip="Editar">
                  <mat-icon>edit</mat-icon>
                </button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="ordemColunasTabela"></tr>
            <tr mat-row *matRowDef="let row; columns: ordemColunasTabela;" class="wow-consulta__row"
              (click)="editar(row.id)"></tr>
          </table>
          <mat-paginator [length]="totalElementos" [pageSize]="tamanho"
            [pageSizeOptions]="pageSizeOptions" (page)="paginar($event)"></mat-paginator>
        </ng-container>
      </mat-card>
    </div>
  </div>
</main>
